import { formatDate } from './dateFormat';
import { buildWorkbookFromAoA, downloadExcelWorkbook } from './exportExcel';

/** Row shape aligned with workforce insights API / Organisation Workforce table export. */
export interface WorkforceInsightsExportRow {
  fullName: string;
  email?: string | null;
  businessUnitName?: string | null;
  departmentsDisplay: string;
  dateOfBirth?: string | null;
  dateOfEngagement?: string | null;
  tenureYearsApprox?: number | null;
  tenureDisplay?: string | null;
  nextWorkAnniversaryLocal?: string | null;
}

const COLUMNS = [
  'Full name',
  'Email',
  'Business unit',
  'Departments',
  'Date of birth',
  'Date of engagement',
  'Tenure (approx. years)',
  'Tenure (display)',
  'Next work anniversary',
] as const;

const SHEET_NAME = 'Workforce';

const COL_WIDTHS = [28, 32, 22, 36, 14, 14, 18, 22, 16];

/** Matrix (header row first) for tests and workbook building. */
export function buildWorkforceInsightsExportMatrix(rows: WorkforceInsightsExportRow[]): (string | number)[][] {
  const headerRow: string[] = [...COLUMNS];
  const dataRows: (string | number)[][] = rows.map((r) => [
    r.fullName,
    r.email ?? '',
    r.businessUnitName ?? '',
    r.departmentsDisplay,
    r.dateOfBirth ? formatDate(r.dateOfBirth) : '',
    r.dateOfEngagement ? formatDate(r.dateOfEngagement) : '',
    r.tenureYearsApprox ?? '',
    r.tenureDisplay ?? '',
    r.nextWorkAnniversaryLocal ? formatDate(r.nextWorkAnniversaryLocal) : '',
  ]);
  return [headerRow, ...dataRows];
}

/** Single-sheet workbook; same content as **Export to Excel** on Organisation Workforce. */
export function buildWorkforceInsightsWorkbook(rows: WorkforceInsightsExportRow[]) {
  return buildWorkbookFromAoA(SHEET_NAME, buildWorkforceInsightsExportMatrix(rows), COL_WIDTHS);
}

/** Same columns as the on-screen table; one sheet, `.xlsx` download. */
export function downloadWorkforceInsightsExcel(rows: WorkforceInsightsExportRow[]): void {
  const wb = buildWorkforceInsightsWorkbook(rows);
  const filename = `workforce-insights-${new Date().toISOString().slice(0, 10)}.xlsx`;
  downloadExcelWorkbook(wb, filename);
}
